/**
 * Compatibility shim — drop-in replacement for Firebase's auth exports.
 *
 * Feature stores and components that used to import from "./firebase" now import
 * from "./auth". The interface mirrors Firebase Auth's auth object so that
 * existing auth.currentUser and onAuthStateChanged patterns keep working without
 * changes to every feature file.
 *
 * SyncAuthToStore calls setCurrentUser() whenever Convex Auth state changes,
 * which populates currentUser and notifies all registered listeners.
 */

let _currentUser = null;
const _listeners = new Set();

export const auth = {
  get currentUser() {
    return _currentUser;
  },

  /** Registers a listener and immediately calls it with the current user. Returns unsubscribe fn. */
  onAuthStateChanged(callback) {
    _listeners.add(callback);
    callback(_currentUser);
    return () => _listeners.delete(callback);
  },
};

/** Called by SyncAuthToStore when Convex Auth state changes. */
export function setCurrentUser(user) {
  if (_currentUser === user) return;
  _currentUser = user;
  _listeners.forEach((cb) => cb(user));
}

/**
 * Firebase-compatible standalone onAuthStateChanged function.
 * Delegates to auth.onAuthStateChanged so existing call-sites
 * that do onAuthStateChanged(auth, callback) keep working.
 */
export function onAuthStateChanged(authInstance, callback) {
  return authInstance.onAuthStateChanged(callback);
}
